<script setup lang="ts">
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from '@/components/ui/dropdown-menu'
import { Plus, Music, Square, ListMusic } from 'lucide-vue-next'
import SpotifyIcon from '@/components/icons/SpotifyIcon.vue'

interface Props {
  isOpen: boolean
  x: number
  y: number
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:isOpen': [value: boolean]
  createScene: []
  addSpotify: []
  addMusic: []
  addPlaylist: []
  createContainer: []
}>()
</script>

<template>
  <DropdownMenu :open="isOpen" @update:open="emit('update:isOpen', $event)">
    <DropdownMenuTrigger
      as="div"
      :style="{
        position: 'fixed',
        left: x + 'px',
        top: y + 'px',
        pointerEvents: 'none',
        visibility: 'hidden'
      }"
    />
    <DropdownMenuContent>
      <DropdownMenuItem @click="emit('createScene')">
        <Plus class="h-4 w-4 mr-2" />
        Create Scene
      </DropdownMenuItem>
      <DropdownMenuItem @click="emit('createContainer')">
        <Square class="h-4 w-4 mr-2" />
        Create Container
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem @click="emit('addSpotify')">
        <SpotifyIcon class="h-4 w-4 mr-2" />
        Add Spotify
      </DropdownMenuItem>
      <DropdownMenuItem @click="emit('addMusic')">
        <Music class="h-4 w-4 mr-2" />
        Add Sound
      </DropdownMenuItem>
      <DropdownMenuItem @click="emit('addPlaylist')">
        <ListMusic class="h-4 w-4 mr-2" />
        Add Playlist
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
